/* eslint-disable flowtype/require-valid-file-annotation */

import React from 'react';
import Snackbar from 'material-ui/Snackbar';
import Dialog, {DialogTitle, DialogContent,DialogContentText,withMobileDialog,} from 'material-ui/Dialog';
import {FormControl,FormControlLabel,FormHelperText} from 'material-ui/Form';
import { MenuItem } from 'material-ui/Menu';
import { InputLabel } from 'material-ui/Input';
import Radio, { RadioGroup } from 'material-ui/Radio';
import Checkbox from 'material-ui/Checkbox';
import Divider from 'material-ui/Divider';
import Typography from 'material-ui/Typography';
import {TextValidator, SelectValidator, ValidatorForm} from 'react-material-ui-form-validator';
import Grid from 'material-ui/Grid';
import ReactDOM from 'react-dom';

import $ from 'jquery';
import LINK from '../constants/LinkConstants.js';
import StateNames from '../constants/state.js';
import Countries from '../constants/country.js';

class AccountInfo extends React.Component {

  constructor(props) {
     super(props);

     if(props.fields){
       this.state = props.fields;
     } else {
       this.state = {
         isAgencyLogin:"false",canSameAccount:true,stateName:"",country:"",canState:"",canCountry:""
       };
     }

     this.validateNow = this.validateNow.bind(this);
  }

  componentDidMount(){
    if(this.props.step0){
      this.setState({fullName:this.props.step0.fullName, clientName:this.props.step0.clientName});
    }
    this.onAgencyLogin(null, "false");
  }

  componentWillMount(){

    ValidatorForm.addValidationRule('isCanRequired', (value) => {
        if(!this.state.canSameAccount){
          if(value==null || value==="" || value===undefined)
            return false;
        }
        return true;
    });
    ValidatorForm.addValidationRule('isAgency', (value) => {
        if(this.state.isAgencyLogin==="true"){
          if(value==null || value==="" || value===undefined)
            return false;
        }
        return true;
    });
    ValidatorForm.addValidationRule('isNotAgency', (value) => {
        if(this.state.isAgencyLogin==="false"){
          if(value==null || value==="" || value===undefined)
            return false;
        }
        return true;
    });
    ValidatorForm.addValidationRule('isPasswordMatch', (value) => {
        if (value !== this.state.password) {
            return false;
        }
        return true;
    });

    var patt = new RegExp("^.*(?=.{8,})(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*+=()-]).*$");
    ValidatorForm.addValidationRule('isPasswordReg', (value) => {
        if (this.state.isAgencyLogin==="false"){
          if(!patt.test(value)) {
              return false;
          }
        }
        return true;
    });
  }

  validateNow = ()  => {
    this.refs.accountform.submit();
  }

  canSameAccount = () => (event, checked) => {
    this.setState({ 'canSameAccount': checked });
    if(checked){
      document.getElementById("canSpamSpan").style.display = "none";
    } else {
      document.getElementById("canSpamSpan").style.display = "block";
    }
  }

  onAgencyLogin = (event, value) =>{
    this.setState({isAgencyLogin:value}, function(){
      if(this.state.isAgencyLogin==="true"){
        document.getElementById("agencyLoginYesSpan").style.display = "block";
        document.getElementById("agencyLoginNoSpan").style.display = "none";
      } else {
        document.getElementById("agencyLoginNoSpan").style.display = "block";
        document.getElementById("agencyLoginYesSpan").style.display = "none";
      }
    })
  }

  //to setstate from all the fields
  handleChange =name=> event=> {
    this.setState({ [name]: event.target.value });
  }

  handleSubmit=() =>{
    if(this.state.isAgencyLogin==="true" && this.state.agencyUserName!=""){
      this.setState({open:true,message:"Please wait while we processing your data..."});
      var params = "agencyUserName="+this.state.agencyUserName;
      $.ajax({
       url: LINK.isAgencyUser+"?"+params,
       cache: false,
       type : 'GET',
       headers: {
         'Accept': 'application/json',
         'Content-Type': 'application/json'
       },
       success: function(response) {
         if(response.status=="error"){
           this.setState({open:true,message:response.msg});
         } else {
           this.setState({open:false});
           this.props.onSubmit(this.state);
         }
       }.bind(this),
       error: function(xhr, status, err) {
         this.setState({open:true,message:"Server is not responding properly. Please try after sometime!"});
       }.bind(this)
     });
   } else {
     if(this.state.user_name!=""){
       this.setState({open:true,message:"Please wait while we processing your data..."});
       var params = "email="+this.state.user_name;
       $.ajax({
        url: LINK.userExists+"?"+params,
        cache: false,
        type : 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        success: function(response) {
          if(response.status=="error"){
            this.setState({open:true,message:response.msg});
          } else {
            this.setState({open:false});
            this.props.onSubmit(this.state);
          }
        }.bind(this),
        error: function(xhr, status, err) {
          this.setState({open:true,message:"Server is not responding properly. Please try after sometime!"});
        }.bind(this)
      });
     }
   }
  }

  handleRequestClose = (event, reason) => {
    this.setState({ open: false });
  };

  handleError=(errors) => {
    if(errors.length>0){
      document.getElementsByName(errors[0].props.name)[0].focus();
    }
  }

  render() {

    var stateList=[];
    var countryList=[];
    for (var stateId in StateNames) {
      if (StateNames.hasOwnProperty(stateId)) {
        var val = StateNames[stateId];
        stateList.push(<MenuItem key={stateId} value={stateId}>{val}</MenuItem>);
      }
    }

    for (var countryId in Countries) {
      if (Countries.hasOwnProperty(countryId)) {
        var cval = Countries[countryId];
        countryList.push(<MenuItem key={countryId} value={countryId}>{cval}</MenuItem>);
      }
    }

    return (
      <div>
        <Divider light />
        <Typography type="title" className="headline">Enter your Account Information</Typography>
        <ValidatorForm ref="accountform" onSubmit={this.handleSubmit}
            onError={this.handleError} >
          <Grid container spacing={24}>
            <Grid item xs={12} sm={10} md={6} lg={4}>
              <TextValidator fullWidth inputProps={{ maxLength: 30 }} inputRef={(firstName)=>{this.firstName = firstName}}
                name="firstName" value={this.state.firstName}
                validators={['required']} errorMessages={['Please enter your primary contact first name']}
                label="Primary Contact First Name*" onChange={this.handleChange('firstName')} />
            </Grid>

            <Grid item xs={12} sm={10} md={6} lg={4}>
              <TextValidator fullWidth inputProps={{ maxLength: 30 }}
                name="lastName" value={this.state.lastName}
                validators={['required']} errorMessages={['Please enter your primary contact last name']}
                label="Primary Contact Last Name*" onChange={this.handleChange('lastName')} />
            </Grid>

            <Grid item xs={12} sm={10} md={6} lg={4}>
              <TextValidator fullWidth name="clientName" value={this.state.clientName} inputProps={{ maxLength: 30 }}
                validators={['required']} errorMessages={['Please enter your company name']}
                label="Company Name*" onChange={this.handleChange('clientName')} />
            </Grid>

            <Grid item xs={12} sm={10} md={6} lg={4}>
              <TextValidator fullWidth name="primaryContactEmail" value={this.state.primaryContactEmail}  inputProps={{ maxLength: 50 }}
                validators={['required','isEmail']} errorMessages={['Please enter your email address','Please enter a valid email']}
                label="Email Address*" onChange={this.handleChange('primaryContactEmail')} />
            </Grid>

            <Grid item xs={12} sm={10} md={6} lg={4}>
              <TextValidator fullWidth name="primaryContactPhone" value={this.state.primaryContactPhone} inputProps={{ maxLength: 30 }}
                validators={['required','isNumber']} errorMessages={['Please enter your phone number,','Please enter only in numeric digits']}
                label="Phone Number*" onChange={this.handleChange('primaryContactPhone')} />
            </Grid>

            <Grid item xs={12} sm={10} md={6} lg={4}>
              <TextValidator fullWidth name="primaryContactFax" value={this.state.primaryContactFax} inputProps={{ maxLength: 30 }}
                label="Fax Number" onChange={this.handleChange('primaryContactFax')} />
            </Grid>

            <Grid item xs={12} sm={10} md={6} lg={4}>
              <TextValidator fullWidth name="address_1" value={this.state.address_1} inputProps={{ maxLength: 30 }}
                validators={['required']} errorMessages={['Please enter your address']}
                label="Address*" onChange={this.handleChange('address_1')} />
            </Grid>

            <Grid item xs={12} sm={10} md={6} lg={4}>
              <TextValidator fullWidth name="address_2" value={this.state.address_2} inputProps={{ maxLength: 30 }}
                label="Address 2" onChange={this.handleChange('address_2')} />
            </Grid>

            <Grid item xs={12} sm={10} md={6} lg={4}>
              <TextValidator fullWidth name="city" value={this.state.city} inputProps={{ maxLength: 30 }}
                validators={['required']} errorMessages={['Please enter your city']}
                label="City*" onChange={this.handleChange('city')} />
            </Grid>

            <Grid item xs={12} sm={10} md={6} lg={4}>

                <SelectValidator name="stateName" style={{width:"100%"}}
                  value={this.state.stateName} onChange={this.handleChange('stateName')}
                  validators={['required']} errorMessages={['Please choose your state']}
                  formControl={FormControl} label="Select your state*">
                  {stateList}
                </SelectValidator>
            </Grid>

            <Grid item xs={12} sm={10} md={6} lg={4}>
              <TextValidator fullWidth name="zip" value={this.state.zip} inputProps={{ maxLength: 10 }}
                validators={['required','isNumber']} errorMessages={['Please enter your postal code','Please enter only numeric digits']}
                label="Postal Code*" onChange={this.handleChange('zip')} helperText="Enter only numeric digits" />
            </Grid>

            <Grid item xs={12} sm={10} md={6} lg={4}>
                <SelectValidator name="country" style={{width:"100%"}}
                  value={this.state.country} onChange={this.handleChange('country')}
                  validators={['required']} errorMessages={['Please choose your country']}
                  formControl={FormControl} label="Select your country*">
                  {countryList}
                </SelectValidator>
            </Grid>

            <Grid item xs={12} className="blockLabel">
              <br/>
              <Divider light />
              <br/>
              <Typography type="title" className="headline">CAN Spam Act Compliance</Typography>
              <br/>
              <FormControlLabel
                control={
                  <Checkbox checked={this.state.canSameAccount} value="canSameAccount"
                    onChange={this.canSameAccount()}/>
                }
                label="This is the same as my account info."
              />
            </Grid>

            <div style={{display:"none",paddingLeft:"12px"}} id="canSpamSpan">
            <Grid container spacing={24}>
              <Grid item xs={12} sm={10} md={6} lg={4}>
                <TextValidator fullWidth name="canCompanyName" value={this.state.canCompanyName} inputProps={{ maxLength: 30 }}
                  validators={['isCanRequired']} errorMessages={['Please enter your company name']}
                  label="Company Name*" onChange={this.handleChange('canCompanyName')} />
              </Grid>

              <Grid item xs={12} sm={10} md={6} lg={4}>
                <TextValidator fullWidth name="canAddress1" value={this.state.canAddress1} inputProps={{ maxLength: 30 }}
                  validators={['isCanRequired']} errorMessages={['Please enter your street address']}
                  label="Street Address 1*" onChange={this.handleChange('canAddress1')} />
              </Grid>

              <Grid item xs={12} sm={10} md={6} lg={4}>
                <TextValidator fullWidth name="canAddress2" value={this.state.canAddress2} inputProps={{ maxLength: 30 }}
                  label="Street Address 2" onChange={this.handleChange('canAddress2')} />
              </Grid>

              <Grid item xs={12} sm={10} md={6} lg={4}>
                <TextValidator fullWidth name="canCity" value={this.state.canCity} inputProps={{ maxLength: 30 }}
                  validators={['isCanRequired']} errorMessages={['Please enter your city']}
                  label="City*" onChange={this.handleChange('canCity')} />
              </Grid>

              <Grid item xs={12} sm={10} md={6} lg={4}>
                <SelectValidator name="canState" style={{width:"100%"}}
                  value={this.state.canState} onChange={this.handleChange('canState')}
                  validators={['isCanRequired']} errorMessages={['Please choose your state']}
                  formControl={FormControl} label="Select your state">
                  {stateList}
                </SelectValidator>
              </Grid>

              <Grid item xs={12} sm={10} md={6} lg={4}>
                <TextValidator fullWidth name="canZip" value={this.state.canZip} inputProps={{ maxLength: 10 }}
                  validators={['isCanRequired']} errorMessages={['Please enter your postal code']}
                  label="Postal Code*" onChange={this.handleChange('canZip')} />
              </Grid>

              <Grid item xs={12} sm={10} md={6} lg={4}>
                  <SelectValidator name="canCountry" style={{width:"100%"}}
                    value={this.state.canCountry} onChange={this.handleChange('canCountry')}
                    validators={['isCanRequired']} errorMessages={['Please choose your country']}
                    formControl={FormControl} label="Select your country">
                    {countryList}
                  </SelectValidator>
              </Grid>
            </Grid>
            <br/>
            </div>

            <br/>

            <Grid item xs={12} className="blockLabel">
              <Divider light />
              <br/>
              <Typography type="title" className="headline">Account Login Setup</Typography>
            </Grid>

            <Grid item xs={12}>
              <FormHelperText>Do you currently have a Gold Lasso agency login?*</FormHelperText>
              <RadioGroup aria-label="isAgencyLogin" name="isAgencyLogin" style={{display:"initial"}}
                onChange={this.onAgencyLogin} value={this.state.isAgencyLogin}>
                <FormControlLabel value="false" control={<Radio className="v_middle"/>} label="No" style={{display:"inline-block",width:"100px"}} />
                <FormControlLabel value="true" control={<Radio className="v_middle"/>} label="Yes" style={{display:"inline-block",width:"100px"}} />
              </RadioGroup>
            </Grid>

            <Grid item xs={12} style={{display:"none"}} id="agencyLoginYesSpan">
              <FormHelperText>Please enter your Agency User-Id*</FormHelperText>
              <TextValidator fullWidth name="agencyUserName" value={this.state.agencyUserName} inputProps={{ maxLength: 50 }}
                validators={['isAgency']} errorMessages={['Please enter your agency username']}
                placeholder="Type your agency user-id*" onChange={this.handleChange('agencyUserName')} />
            </Grid>

            <Grid item xs={12} style={{display:"none"}} id="agencyLoginNoSpan">
              <Grid item xs={12}>
                <FormHelperText>Please use your email address as your login*</FormHelperText>
                <TextValidator fullWidth name="user_name" value={this.state.user_name} inputProps={{ maxLength: 30 }}
                  validators={['isNotAgency']} errorMessages={['Please enter your email address']}
                  placeholder="Enter a valid email address*" onChange={this.handleChange('user_name')}/>
                  <br/><br/>
              </Grid>
              <Grid item xs={12}>
                <FormHelperText>Please choose an alphanumeric password (min 5 chars)*</FormHelperText>
                <TextValidator fullWidth type="password" name="password" value={this.state.password} inputProps={{ maxLength: 30 }}
                  validators={['isPasswordReg','isNotAgency']}
                  errorMessages={["1. Must be at least 8 characters \n" +
                  "2. Must contain at least one one lower case letter, one upper case letter, one digit and one special character \n" +
                  "3. Valid special characters are - !@#$%^&*+=()-",'Please enter your password']}
                  placeholder="Type your alphanumeric password*" onChange={this.handleChange('password')}/>
                  <br/><br/>
              </Grid>
              <Grid item xs={12}>
                <FormHelperText>Retype password*</FormHelperText>
                <TextValidator fullWidth type="password" name="passwordConfirm" value={this.state.passwordConfirm} inputProps={{ maxLength: 30 }}
                  validators={['isNotAgency', 'isPasswordMatch']} errorMessages={['Please enter your confirm password','Passwords must match']}
                  placeholder="Password should be same as above*" onChange={this.handleChange('passwordConfirm')}/>
                  <br/><br/>
              </Grid>
            </Grid>

          </Grid>

        </ValidatorForm>

        <Dialog open={this.state.open}
          onClose={this.handleRequestClose} aria-labelledby="responsive-dialog-title" >
          <DialogContent>
            <DialogContentText>
              {this.state.message}
            </DialogContentText>
          </DialogContent>

        </Dialog>
      </div>
    );
  }
}

export default AccountInfo;



// WEBPACK FOOTER //
// ./src/components/accountinfo.js